/**
 * Placeholder card shown while a list loads.
 *
 * It reserves exactly the space a real card occupies, so the grid does not jump
 * when data arrives — that jump is what Cumulative Layout Shift measures.
 */
function CardSkeleton() {
  return (
    <div className="blog-card blog-card-skeleton" aria-hidden="true">
      <div className="blog-card-media skeleton" />
      <div className="blog-card-body">
        <span className="skeleton skeleton-chip" />
        <span className="skeleton skeleton-line skeleton-line-lg" />
        <span className="skeleton skeleton-line" />
        <span className="skeleton skeleton-line skeleton-line-sm" />
      </div>
    </div>
  );
}

export default CardSkeleton;
